export enum OperationStatusEnum {
  ok = 'OK',
  error = 'ERROR'
}
